module.exports = __webpack_public_path__ + "img/main.173f98b8.png";